export var GAActions = {
  HOMEPAGE: 'Homepage',
  SEARCH_BUTTON: 'Search Button'
};
export var GALabels = {
  SCHOOL_SEARCH: 'School Search',
  PROJECT_SEARCH: 'Project Search',
  ADDRESS_SEARCH: 'Address Search',
  SCHOOL_SEARCH_TOOLTIP_APPEAR: 'Display School Search Tooltip',
  SCHOOL_SEARCH_TOOLTIP_CLOSE: 'Close School Search Tooltip',
  NEWS_TAB: 'News and Advice Tab'
};